import { ReactElement } from 'react';

import { CallToActionButton } from 'components/Button';
import { AnchorButton } from 'components/Button/AnchorButton';

type Props = {
  loggedIn: boolean;
  pageUrl: string;
  blockId: string;
  buttonUrl: string | undefined;
  buttonText: string | undefined;
  isGrad: boolean;
  hasGradProgram: boolean;
};

export function CmsAmpHeroBlockButton({
  loggedIn,
  pageUrl,
  blockId,
  buttonUrl,
  buttonText,
  isGrad,
  hasGradProgram,
}: Props): ReactElement | null {
  if (buttonUrl && buttonText) {
    return <AnchorButton href={buttonUrl}>{buttonText}</AnchorButton>;
  }

  if (isGrad) {
    return (
      <CallToActionButton loggedIn={loggedIn} hasGradProgram={hasGradProgram} />
    );
  }

  if (buttonText) {
    return (
      <AnchorButton href={`${pageUrl}#cms-block-${blockId}`}>
        {buttonText}
      </AnchorButton>
    );
  }

  return null;
}
